import actionTypes from '../constants/action-types';

const setActivePage = (pageId, resolve = Function.prototype, reject = Function.prototype) => ({
  type: actionTypes.SET_ACTIVE_PAGE,
  payload: {
    pageId,
    resolve,
    reject,
  },
});

export default setActivePage;
